module.exports = {
  "general.days": "giorni",
  "general.day": "giorno",
  "general.select-days": "Seleziona giorni",
  "general.select-day": "Seleziona giorno",
  "general.selected-days": "Giorni selezionati",
  "general.selected-day": "Giorno selezionato",
  "general.continue": "Continua",
  "general.reservation": "Prenotazione",
  "general.country": "Paese",
  "general.guest": "Ospite",
  "general.guests": "Ospiti",
  "general.guests.one": "1 Ospite",
  "general.guests.other": "{0} Ospiti",
  "general.single.beds.one": "1 Letto singolo",
  "general.single.beds.other": "{0} Letti singoli",
  "general.double.beds.one": "1 Letto matrimoniale",
  "general.double.beds.other": "{0} Letti matrimoniali",
  "general.interests": "Interessi",
  "general.interests_hostz": "Informazioni sull'arrivo",
  "general.interests_offgrid": "Interessi",
  "general.payments": "Pagamenti",
  "general.summary": "Riepilogo",
  "general.summary_offgrid": "Overview",
  "general.back": "Indietro",
  "general.buy": "Acquista",
  "general.go-back": "Torna indietro",
  "general.next": "Avanti",
  "general.next_offgrid": "Next",
  "general.confirm": "Conferma",
  "general.cancel": "Annulla",
  "general.close": "Chiudi",
  "general.save": "Salva",
  "general.stay": "Soggiorno",
  "general.identify-using-qr": "Identificami con QR",
  "general.identify-using-code": "Identificami con il codice",
  "general.identify-welcome": "Benvenuto",
  "general.identify-welcome-phrase": "Procedi per completare il pre-check-in così avremo tutto pronto per il tuo arrivo.",
  "general.identify-welcome-phrase-offgrid": "Please complete your online check-in as soon as possible. You will receive the arrival information one day before your arrival.",

  "general.identify-screen.title": "Accedi al tuo assistente digitale per il soggiorno:",
  "general.identify-screen.subtitle": "Con il tuo codice di prenotazione o i tuoi dati se sei già in hotel",
  "general.identify-screen.subtitle-1": "Compila i dati per continuare",
  "general.identify-screen.subtitle-2": "Per favore, compila i seguenti dati per continuare",
  "general.identify-screen.button-code": "Ho un codice di prenotazione",
  "general.identify-screen.button-data": "Sono già in hotel",
  "general.identify-screen.button-identify": "Continua",
  "general.identify-screen.button-return-code": "Torna all'identificazione tramite codice",
  "general.identify-screen.button-return-data": "Torna all'identificazione con i dati della prenotazione",
  "general.identify-screen.error-code": "Non siamo riusciti a trovare il codice di prenotazione indicato, riprova per favore!",
  "general.identify-screen.error-data": "Non siamo riusciti a trovare la prenotazione con i dati indicati, riprova per favore!",
  "general.identify-screen.title-hostz": "Accedi ora e visualizza il portale ospiti:",
  "general.active": "Attivo",
  "general.inactive": "Inattivo",
  "general.go-to-detail": "Vai al Dettaglio",
  "general.go_to_website": "Scopri di più",
  "general.go-to-my-stay": "Vai al Mio Soggiorno",
  "general.guidelines": "Linee guida",
  "general.price": "Prezzo",
  "general.report": "Segnala",
  "general.edit": "Modifica",
  "general.checkin_edit": "Modifica Info Check-in",
  "general.experiences": "Esperienze",
  "general.request": "Richiedi",
  "general.send": "Invia",
  "general.detail": "Dettaglio",
  "general.no-charge": "Gratis",
  "general.yes": "SÌ",
  "general.no": "NO",
  "general.dateformat": "dd-MM-yyyy",
  "general.short-dateformat": "dd-MM",
  "general.day": "Giorno",
  "general.date": "Data",
  "general.hour": "Ora",
  "general.time": "Ora",
  "general.qty": "Q.tà",
  "general.reserve": "Prenota",
  "general.from": "Da",
  "general.to": "A",
  "general.total": "Totale",
  "general.duration": "Durata",
  "general.chat": "Chat",
  "general.services": "Servizi",
  "general.equipment": "Attrezzatura",
  "general.features": "Caratteristiche",
  "general.remove": "Rimuovi",
  "general.upload": "Carica",
  "general.upload-file": "Carica File",
  "general.balance": "Saldo",
  "general.checkout": "Check-out",
  "general.accept": "Accetta",
  "general.clear": "Pulisci",
  "general.send_comment": "Invia Commento",
  "general.menu": "Menu",
  "general.start.checkin": "Avvia Check-in",
  "general.placeOrder": "Effettua Ordine",
  "general.updateOrder": "Aggiorna Ordine",
  "general.please": "Per favore",
  "general.touch": "Tocca ",
  "general.key_explanation": "Questa chiave sarà fornita dal concierge",
  "general.selected": "Selezionato",
  "general.select-date": "Seleziona giorno, orario e numero di persone per la tua prenotazione",
  "general.today": "Oggi",
  "general.time-format": " ore",
  "general.yesterday": "Ieri",
  "general.tomorrow": "Domani",
  "general.no-schedule-available": "Spiacenti, nessun orario disponibile",
  "general.fields_required": "sono campi obbligatori",
  "general.about": "Informazioni",
  "general.type_message": "Scrivi qui il tuo messaggio...",
  "general.items.qty": "Q.tà Articoli",
  "general.add-to-home-screen-text": "Puoi aggiungere questa pagina alla schermata principale per un accesso rapido.",
  "general.add-to-home-screen-button": "Aggiungi alla schermata principale",
  "general.hs": ":00",
  "general.hs-abrev": ".",
  "general.min": "min",
  "general.select_option": "Scegli un'opzione...",
  "general.customization": "Configura il tuo componente aggiuntivo...",

  "hotel.website": "Sito web",
  "hotel.phones": "Telefoni",
  "hotel.address": "Indirizzo",
  "hotel.contact-us": "Contattaci",
  "hotel.social-networks": "Social Network",
  "hotel.please-feel":
    "Non esitare a contattarci! Informazioni di contatto qui sotto.",
  "hotel.location": "Posizione",
  "hotel.conditioning-air-in-common-spaces":
    "Aria condizionata negli spazi comuni",
  "hotel.parking": "Parcheggio",
  "hotel.free-parking": "Parcheggio gratuito",
  "hotel.pay-parking": "Parcheggio a pagamento",
  "hotel.bar": "Bar",
  "hotel.aesthetic-center": "Centro estetico",
  "hotel.kids-club": "Club per bambini",
  "hotel.luggage-storage": "Deposito bagagli",
  "hotel.breakfast": "Colazione",
  "hotel.breakfast-buffet": "Colazione a buffet",
  "hotel.smoke-free-space": "Area non fumatori",
  "hotel.fitness-center": "Centro fitness",
  "hotel.gay-friendly": "Gay Friendly",
  "hotel.hydromassage": "Idromassaggio",
  "hotel.gardens": "Giardini",
  "hotel.masseuse-available": "Massaggiatore disponibile",
  "hotel.water-park": "Parco acquatico",
  "hotel.hairdressing": "Parrucchiere",
  "hotel.bilingual-staff-english-spanish":
    "Personale bilingue (inglese / spagnolo)",
  "hotel.pet-friendly": "Animali ammessi",
  "hotel.pool": "Piscina",
  "hotel.smoking-points": "Aree fumatori",
  "hotel.reception-24-hs": "Reception 24h",
  "hotel.restaurant": "Ristorante",
  "hotel.restaurant-to-the-card": "Ristorante à la carte",
  "hotel.theme-restaurant": "Ristorante a tema",
  "hotel.congress-hall": "Sala congressi",
  "hotel.meeting-room": "Sala riunioni",
  "hotel.sauna": "Sauna",
  "hotel.laundry-service": "Servizio lavanderia",
  "hotel.babycare-service": "Servizio babycare",
  "hotel.spa": "Spa",
  "hotel.theater": "Teatro",
  "hotel.terraces": "Terrazze",
  "hotel.souvenir-shop": "Negozio di souvenir",
  "hotel.airport-transfer": "Trasferimenti aeroportuali su richiesta",
  "hotel.covid.protected-medical-area": "Area medica protetta",
  "hotel.covid.virtual-check-in-out": "Check-in/out virtuale",
  "hotel.covid.temperature-check": "Controllo della temperatura",
  "hotel.covid.first-aid-kit-available": "Kit di primo soccorso disponibile",
  "hotel.covid.separation-screens-for-personnel":
    "Schermi di separazione per il personale",
  "hotel.covid.contactless-payment-available":
    "Pagamento contactless disponibile",
  "hotel.covid.sanitizers-in-common-areas": "Disinfettanti nelle aree comuni",
  "hotel.covid.use-of-specific-cleaning-articles-for-covid": "Uso di articoli di pulizia specifici per Covid",

  "checkin.checkin.preparing-title": "Preparazione del tuo Check-in",
  "checkin.checkin.preparing-text": "Per favore, non chiudere o aggiornare questa finestra.",

  "checkin.status": "Stato del Check-in",
  "checkin.status-pending": "In attesa",
  "checkin.status-observed": "Azione richiesta",
  "checkin.status-to_validate": "In elaborazione",

  "checkin.status-to_validate-text--": "<b>È tutto per ora!</b> Verificheremo le informazioni e ti invieremo un messaggio di conferma a breve! Saluti!",
  "checkin.status-to_validate-text": "<b>Questo è tutto per ora!</b> Grazie per aver completato il web check-in. Cordiali saluti",

  "checkin.status-in_progress": "In corso",
  "checkin.status-accepted": "Accettato",
  "checkin.status-accepted-text": "<b>Il tuo Check-in è stato completato con successo!</b> Non vediamo l'ora di averti! Buon viaggio!",
  "checkin.status-no_show": "No Show",
  "checkin.status-no_show-text": "Contattaci tramite il pulsante di chat qui sotto nel caso in cui tu voglia riprogrammare la tua prenotazione originale. Speriamo di vederti presto!",
  "checkin.status-canceled": "Annullato",
  "checkin.status-canceled-text": "La tua prenotazione è stata annullata. Contattaci tramite il pulsante di chat qui sotto se pensi che sia un errore o se desideri modificarla. Grazie!",
  "checkin.status-done": "Check-out Effettuato",
  "checkin.status-done-text": "Il tuo soggiorno è stato completato! Mettiti in contatto con noi tramite il pulsante di chat qui sotto. Grazie!",
  "checkin.please-complete": "Si prega di compilare questo modulo per completare il processo di check-in. Se hai già un codice di check-in inseriscilo ",
  "checkin.not-forget": "Non dimenticare di aggiungere tutte le persone che viaggiano con te. Potrai inserire le loro informazioni dopo aver completato questo modulo.",
  "checkin.initiated": "Il mio Check-in",
  "checkin.stay": "Soggiorno",
  "checkin.in": "Data di entrata",
  "checkin.out": "Data di partenza",
  "checkin.travel-type": "Tipo di Viaggio",
  "checkin.inputs.select": "Seleziona",
  "checkin.inputs.email": "Email",
  "checkin.inputs.travelType": "Tipo di Viaggio",
  "checkin.inputs.dni-number": "Numero",
  "checkin.inputs.dni-number-offgrid": "Numero",
  "checkin.inputs.dni-issue-date": "Data di rilascio",
  "checkin.inputs.dni-issue-date-offgrid": "Data di rilascio",
  "checkin.inputs.dni-issue-date-simplex": "Data di rilascio",
  "checkin.inputs.dniType": "Tipo di documento",
  "checkin.inputs.zipCode": "CAP",
  "checkin.inputs.dni": "Numero documento",
  "checkin.inputs.dniIssueDate": "Data di rilascio documento",
  "checkin.inputs.dniIssueDate-offgrid": "Data di rilascio documento",
  "checkin.inputs.dniIssueDate-simplex": "Data di rilascio documento",
  "checkin.inputs.name": "Nome",
  "checkin.inputs.surname": "Cognome",
  "checkin.inputs.gender": "Genere",
  "checkin.inputs.gender.male": "Maschio",
  "checkin.inputs.gender.female": "Femmina",
  "checkin.inputs.gender.other": "Altro",
  "checkin.inputs.date-of-birth": "Data di nascita",
  "checkin.inputs.address": "Indirizzo",
  "checkin.inputs.postal-code": "CAP",
  "checkin.inputs.nationality": "Nazionalità",
  "checkin.inputs.residence": "Residenza",
  "checkin.inputs.country_of_residence": "Paese di residenza",
  "checkin.inputs.birthday": "Data di nascita",
  "checkin.inputs.city": "Città",
  "checkin.inputs.phone": "Telefono",
  "checkin.inputs.passenger": "Dati del passeggero",
  "checkin.inputs.photos_dniFront": "Parte anteriore del documento",
  "checkin.inputs.photos_dniBack": "Parte posteriore del documento",
  "checkin.inputs.photos_selfie": "Selfie",

  "checkin.inputs.entryTime": "Orario di arrivo",
  "checkin.inputs.arrivalMode": "Come arriverai?",
  "checkin.inputs.extraData_qtyAdults": "Adulti",
  "checkin.inputs.extraData_qtyChild": "Bambino",
  "checkin.inputs.extraData_qtyBabies": "Neonati",
  "checkin.company-information": "Informazioni sulla Società",
  "checkin.company-information-text": "Si prega di fornire le informazioni sulla società.",
  "checkin.company-name": "Nome",
  "checkin.company-name-placeholder": "Inserisci il nome",
  "checkin.company-address": "Indirizzo",
  "checkin.company-address-placeholder": "Inserisci l'indirizzo",
  "checkin.company-country": "Paese",
  "checkin.company-country-placeholder": "Seleziona il paese",
  "checkin.company-zip-code": "CAP",
  "checkin.company-zip-code-placeholder": "Inserisci il CAP",
  "checkin.company-city": "Città",
  "checkin.company-city-placeholder": "Inserisci la città",
  "checkin.identificate": "Verificare l'identità",

  "checkin.passenger": "Ospite",
  "checkin.passengers": "Ospiti",
  "checkin.passengers-list": "Lista degli ospiti",
  "checkin.passengers-error-incomplete": "Si prega di completare le informazioni dell'ospite",
  "checkin.add-passenger": "Aggiungi ospite",
  "checkin.arrivalMode": "Modalità di arrivo",
  "checkin.arrivalMode-hostz": "Come arriverai?",
  "checkin.arrivalMode-text": "Seleziona la modalità di arrivo",
  "checkin.arrivalMode.airplane": "Aereo",
  "checkin.arrivalMode.public_transportation": "Trasporto pubblico (autobus/treno)",
  "checkin.arrivalMode.train": "Treno",
  "checkin.arrivalMode.bus": "Autobus",
  "checkin.arrivalMode.car": "Auto",
  "checkin.arrivalMode.other": "Altro",
  "checkin.save-checkin": "Salva il check-in",
  "checkin.save-changes": "Salva modifiche",
  "checkin.update-info": "Aggiorna informazioni",
  "checkin.reservation-data": "Informazioni sulla prenotazione",
  "checkin.request-photos":
    "Assicurati che le immagini siano a fuoco e leggibili. Puoi ritagliarle e ridimensionarle dopo averle scattate.",
  "checkin.reviewing":
    "Grazie! Stiamo esaminando la tua richiesta. Riceverai una notifica riguardo <b>lo stato del tuo check-in</b> a breve.",
  "checkin.remember-can":
    "Ricorda che puoi ancora modificare le informazioni del check-in.",
  "checkin.can-see":
    "Puoi vedere la cronologia del check-in e aggiungere un commento qui sotto.",
  "checkin.please-read-to-change":
    "Leggi le informazioni di seguito e apporta le modifiche necessarie per procedere.",
  "checkin.modify": "Modifica",
  "checkin.edit-data": "Modifica dati",
  "checkin.accept": "Accetta",
  "checkin.dni-front": "Parte anteriore del documento",
  "checkin.dni-back": "Parte posteriore del documento",
  "checkin.camera": "Fotocamera",
  "checkin.date-of-birth": "Data di nascita",
  "checkin.age": "Età",
  "checkin.add-comment": "Aggiungi commento",
  "checkin.me": "Io",
  "checkin.accepted-text":
    "<b>Il tuo check-in è stato accettato!</b> Non vediamo l'ora di vederti! Ricorda che puoi chiedere qualsiasi cosa nella sezione commenti qui sotto. Buon viaggio!",
  "checkin.canceled-text":
    "<b>Il tuo check-in è stato annullato.</b> Leggi i commenti qui sotto per sapere come procedere. Grazie!",
  "checkin.new-checkin": "Nuovo check-in",
  "checkin.use-button-to-add-guest":
    "Usa il pulsante qui sotto per aggiungere altri ospiti.",
  "checkin.identified": "Check-in identificato!",
  "checkin.identify-error":
    "Non siamo riusciti a trovare il codice di prenotazione indicato, riprova!",
  "checkin.time-of-arrival": "Orario di arrivo",
  "checkin.time-of-arrival-text":
    "Se hai già un orario stimato di arrivo, faccelo sapere qui.",
  "checkin.time-of-arrival-text2": "Ricorda che il nostro check-in garantito è alle {0}hs.",
  "checkin.time-of-arrival-text2-hostz": "Ricorda che il nostro check-in garantito è alle {0}hs.",
  "checkin.time-of-arrival-text2-offgrid": "La tua camera è pronta alle {0}hs.",
  "checkin.time-of-arrival-early-checkin":
    "Richiedi <b>Check-In Anticipato</b> <span class='text-muted'>(soggetto a disponibilità)</span>",
  "checkin.e-mail": "E-Mail",
  "checkin.phone": "Telefono",
  "checkin.guest-data": "Dati ospite",
  "checkin.guest-data-text":
    "Completa le informazioni mancanti per completare il processo di check-in online.",
  "checkin.guest-complete-later": "Completa queste informazioni in seguito.",
  "checkin.id-type.id": "Documento",
  "checkin.id-type.passport": "PASSAPORTO",
  "checkin.id-type.nif": "NIF",
  "checkin.id-type.nie": "NIE",
  "checkin.type-of-travel": "Tipo di viaggio",
  "checkin.type-of-travel-text":
    "Personalizzeremo la tua esperienza in base alle tue preferenze e necessità.",
  "checkin.travel-type.couple": "Coppia",
  "checkin.travel-type.congress": "Congresso",
  "checkin.travel-type.family": "Viaggio in famiglia",
  "checkin.travel-type.business": "Lavoro",
  "checkin.travel-type.event": "Evento",
  "checkin.travel-type.friends": "Viaggio con amici",
  "checkin.travel-type.relaxing": "Relax",
  "checkin.travel-type.party": "Viaggio di festa",
  "checkin.travel-type.single_traveler": "Viaggiatore singolo",
  "checkin.travel-type.leisure": "Viaggio di piacere",
  "checkin.room-preferences": "Preferenze stanza",

  "checkin.room-preferences-text": "Hai delle preferenze per la tua camera? <br />Facci sapere qui:",
  "checkin.room-preferences.close-to-elevator": "Vicino all'ascensore",
  "checkin.room-preferences.far-from-elevator": "Lontano dall'ascensore",
  "checkin.room-preferences.wheelchair-accessible": "Accessibile in sedia a rotelle",
  "checkin.room-preferences.lower-floor": "Piano basso",
  "checkin.room-preferences.higher-floor": "Piano alto",
  "checkin.take-care-environment": "Vuoi contribuire a prenderti cura dell'ambiente?",
  "checkin.take-care-environment-text": "Piccole azioni possono ridurre significativamente la tua impronta ambientale durante il soggiorno.",
  "checkin.take-care-environment.housekeeping-frequency": "Frequenza delle pulizie",
  "checkin.take-care-environment.housekeeping-frequency.everyday": "Ogni giorno",
  "checkin.take-care-environment.housekeeping-frequency.every-other-day": "Ogni due giorni",
  "checkin.take-care-environment.housekeeping-frequency.do-not-clean-my-room": "Non pulire la mia stanza",
  "checkin.take-care-environment.towell-replacement-frequency": "Frequenza sostituzione asciugamani",
  "checkin.take-care-environment.towell-replacement-frequency.do-not-change": "Non cambiare gli asciugamani",
  "checkin.take-care-environment.towell-replacement-frequency.everyday": "Ogni giorno",
  "checkin.take-care-environment.towell-replacement-frequency.every-other-day": "Ogni due giorni",
  "checkin.restaurant-reservation": "Sono interessato a prenotare nel vostro <b>ristorante/i</b>",
  "checkin.comments": "Commenti",
  "checkin.comments-text": "Per favore, facci sapere se possiamo fare qualcosa per migliorare il tuo soggiorno con noi.",
  "checkin.review-the-summary": "Rivedi il riepilogo del tuo Check-in online. Puoi tornare indietro e modificare le informazioni fornite. Se tutto è corretto premi il pulsante <b>\"Conferma\"</b> qui sotto.",
  "checkin.reservation-code": "Codice di prenotazione",
  "checkin.in-out": "Arrivo / Partenza",
  "checkin.primary-guest": "Ospite principale",
  "checkin.guests-text": "Abbiamo bisogno di queste informazioni per determinare la configurazione migliore dei letti per il tuo soggiorno e garantire il tuo comfort.<br /><br /><small>Adulti (15+ anni) / Bambino (3-14 anni) / Neonati (0-2 anni)</small>",
  "checkin.adult-s": "Adulti",
  "checkin.adults": "Adulti",
  "checkin.adult": "Adulto",
  "checkin.short-room": "Camera",
  "checkin.room": "Camera",
  "checkin.select-door-open": "Seleziona quale porta desideri aprire...",
  "checkin.select-door-open-hostz": "Fai clic sulla porta che desideri aprire",
  "checkin.select-door-open-themyde": "Scegli la porta che desideri aprire e scorri il pulsante",
  "checkin.select-photo-source-to": "Seleziona la fonte della foto per ",
  "checkin.use-camera": "Usa la fotocamera",
  "checkin.click-edit-data-text1": " per apportare le modifiche necessarie. Una volta completate, premi ",
  "checkin.click-edit-data-text2": " e poi ",
  "checkin.click-edit-data-text3": ". Grazie per la collaborazione!",
  "checkin.do-not-disturb": "Non disturbare",
  "checkin.floor-selection": "Problemi di mobilità?",
  "checkin.floor-selection-text": "Seleziona il piano in cui desideri soggiornare. Si prega di notare che non abbiamo ascensori.",
  "checkin.ground-floor": "Ho problemi di mobilità e ho bisogno di pochi gradini",
  "checkin.first-floor": "Primo piano",
  "checkin.indifferent": "Indifferente",
  "checkin.entry-time-not-know-yet": "Non lo so ancora",
  "checkout.loading-information": "Attendere mentre raccolgo tutte le informazioni necessarie.",
  "checkout.errors-title": "Impossibile elaborare il Check-out",
  "checkout.error-balance": "Il tuo saldo è {0}. Si prega di saldare il conto per procedere.",
  "checkout.error-departure": "La data di Check-out è {0}. Vuoi abbreviare il soggiorno?",
  "checkout.button": "Continua con il Check-out",
  "checkout.error-departure-button": "Hai bisogno di aiuto? Chattiamo!",
  "checkout.error-noShowBalance": "Hai bisogno di assistenza o hai domande? Siamo qui per te! Fai clic sul pulsante della chat qui sotto per metterti in contatto. Vuoi cancellare il tuo account? Puoi farlo facilmente qui. Ricorda, la tua soddisfazione è la nostra priorità!",
  "checkout.success-title": "Il tuo Check-out è stato completato con successo!",
  "checkout.debt": "Non possiamo elaborare il Check-out. Hai un saldo in sospeso di: ",
  "checkout.pay_now": "Paga ora",
  "checkout.ask_for_balance": "Non possiamo elaborare il Check-out in questo momento. Contattaci per ulteriori istruzioni.",
  "checkin.selfie.preview-title": "Selfie",
  "checkin.selfie.preview-text": "Ritaglia l'immagine per centrare il tuo viso.",
  "checkin.dniFront.preview-title": "Fronte documento",
  "checkin.dniFront.preview-text": "Ritaglia l'immagine per centrare correttamente il documento.",
  "checkin.dniBack.preview-title": "Retro documento",
  "checkin.dniBack.preview-text": "Ritaglia l'immagine per centrare correttamente il documento.",
  "checkin.redirecting": "Reindirizzamento in {0} secondi...",
  "checkin.camera.repeat": "Ripeti",
  "checkin.camera.crop": "Ritaglia",
  "checkin.camera.use-photo": "Usa foto",
  "checkin.reservation-conditions-text": "La direzione non è responsabile per oggetti di valore lasciati nella stanza degli ospiti.<br /><br /><b>Il Check-out è alle 11:00 a.m.</b><br /><br /><span class='text-danger font-weight-bold'>Vietato fumare in tutte le stanze e nelle aree comuni.</span><br />È consentito fumare solo all'esterno dell'edificio. In caso di fumo nella stanza verrà addebitata una tassa di pulizia di 250,00 Euro.<br /><br /><small>I dati sopra indicati sono gestiti tramite EDP.</small>",
  "checkin.reservation-conditions-text-offgrid": "<b>Check-in:</b> dalle 15:00<br/><b>Check-out:</b> entro le 11:00 <br/><ul><li>È vietato fumare in tutte le nostre cabine.</li><li>Si prega di notare che solo gli ospiti registrati possono soggiornare e pernottare nella cabina. Il numero massimo di ospiti è di 2 persone.</li><li>Si prega di segnalare immediatamente eventuali danni o difetti tramite “Segnalazione danni“ nella tua guida o contattaci tramite la nostra hotline: +49 30 54806375.</li><li>Travel to and use of our off-grid accommodations are at your own risk; we accept no liability for weather-related restrictions, road conditions, or accidents. Detailed regulations can be found in our terms and conditions.</li></ul><br/>Una panoramica delle regole della cabina è disponibile nella tua guida di viaggio alla voce “La tua cabina“ -> “Regole della cabina“.",
  "checkin.gdpr-text1": "Firmando qui sotto, acconsento al trattamento dei miei dati personali in conformità con le",
  "checkin.gdpr-text2": ". Capisco che posso revocare il mio consenso in qualsiasi momento.",
  "checkin.gdpr-text-nexo": "e le",

  "checkin.gdpr-text1-costa": "By signing below, I consent to the processing of my personal data as outlined in the",
  "checkin.gdpr-text2-costa": ", and I declare that I am not a tax resident in the Argentine Republic, as per ",
  "checkin.gdpr-text-nexo-costa": ", and understand that I can withdraw my consent at any time. I also confirm that I have read and accept the ",
  "checkin.gdpr-text3-costa": "I declare that my stay in Argentina is for tourism and does not exceed the legally allowed period, in order to request a VAT refund under Law N° 3971 (AFIP) and Resolution N° 566.",
  "checkin.gdpr-button-2-popup": "I declare that my stay in Argentina does not exceed the stablished maximum term, according to the current immigration legislation and my reason to visit Argentina is for tourism only.<br />The present AFFIDAVIT serves for the purposes of issuing the VAT exemption request, due to the General Resolution N° 3971(AFIP) and Resolution N°566(tourism)",

  "checkin.gdpr-text1-hostz": "Firmando qui sotto, acconsento al trattamento dei miei dati personali in conformità con i",
  "checkin.gdpr-text2-hostz": ".",
  "checkin.gdpr-text-nexo-hostz": " e comprendo che posso revocare il mio consenso in qualsiasi momento.<br/><br/>Riconosco e accetto di rispettare i ",

  "checkin.gdpr-text1-simplex": "Firmando qui sotto, acconsento al trattamento dei miei dati personali in conformità con i",
  "checkin.gdpr-text2-simplex": ".",
  "checkin.gdpr-text-nexo-simplex": " e comprendo che posso revocare il mio consenso in qualsiasi momento.<br/><br/>Riconosco e accetto di rispettare i ",

  "checkin.gdpr-text1-offgrid": "Firmando qui sotto, accetto il trattamento e l'uso dei miei dati personali in conformità con la",
  "checkin.gdpr-text2-offgrid": " di Offgrid Mindful Cabins.",
  "checkin.gdpr-text-nexo-offgrid": " e accetto i ",

  "checkin.gdpr-button": "Politica sulla privacy",
  "checkin.gdpr-button-1": "Regolamento Hotel",
  "checkin.gdpr-button-1-simplex": "Regolamento Hotel",
  "checkin.gdpr-button-1-hostz": "Regolamento Hotel",
  "checkin.gdpr-button-1-hostz-swissstay": "Regolamento",
  "checkin.gdpr-button-1-offgrid": "General Terms & Conditions",

  "checkin.terms-and-conditions": "Termini e condizioni",
  "checkin.hotel-regulations": "Regolamento Hotel",
  "checkin.the_myde_selfie_message": "Carica un <b>selfie di te che tieni il tuo documento di identità</b> (passaporto, carta d’identità o carta di guida). Questo ci aiuta a mantenere il tuo soggiorno sicuro e senza problemi.",
  "checkin.terms-and-conditions-button-detail": "del soggiorno in hotel",

  "checkin.signature": "Firma",
  "checkin.please-sign-here": "Tocca qui per firmare",
  "checkin.please-sign-below": "Firma qui sotto",
  "checkin.confirm": "Conferma",
  "checkin.newsletter": "Newsletter",
  "checkin.newsletter-optin": "Desidero ricevere notizie e offerte dell'hotel via email",
  "checkin.child": "Bambino",
  "checkin.child-s": "Bambini",
  "checkin.children": "Bambini",
  "checkin.no-children": "Senza bambini",
  "checkin.babies": "Neonati",
  "checkin.years": "anni",
  "checkin.no.name.yet": "Nome non ancora fornito.",
  "checkin.dniFront.required": "Il fronte del documento è richiesto",
  "checkin.selfie.required": "Il selfie è richiesto",
  "checkin.dniBack.required": "Il retro del documento è richiesto",
  "checkin.the_myde_selfie_message_title": "Importante!",
  "checkin.please-complete-your-checkin-title": "Check-in in sospeso",
  "checkin.please-complete-your-checkin-text": "Completa il tuo Check-in cliccando qui.",
  "general.notifications": "Notifiche",
  "general.notifications_description": "Le tue impostazioni personali in questa app per personalizzare la tua esperienza.",
  "cups.title": "Extra",
  "cups.remove_button": "Rimuovi",
  "cups.add_button": "Aggiungi",
  "cups.subject_to_availability": "Soggetto a disponibilità",
  "cups.subject_to_availability_text": "Questo articolo è soggetto a disponibilità. Durante questo processo, non verranno addebitati costi e, una volta selezionato, un rappresentante dell'hotel ti contatterà per fornirti ulteriori dettagli.",
  "cups.preferedList_text": "In base ai tuoi interessi abbiamo queste esperienze per te",
  "cups.otherList_text": "Forse queste esperienze potrebbero interessarti",


  "cups.tags.best-selling": "Più Venduto",
  "cups.tags.most-popular": "Più Popolare",
  "cups.tags.best-price": "Miglior Prezzo",
  "cups.priceIsPerNight": "per notte",
  "cups.confirm": "Confermi questo acquisto?",
  "cups.booked": "Prenotato",
  "cups.spots": "posti",

  "date.january": "Gennaio",
  "date.february": "Febbraio",
  "date.march": "Marzo",
  "date.april": "Aprile",
  "date.may": "Maggio",
  "date.june": "Giugno",
  "date.july": "Luglio",
  "date.august": "Agosto",
  "date.september": "Settembre",
  "date.october": "Ottobre",
  "date.november": "Novembre",
  "date.december": "Dicembre",

  "maps.how_to_reach_us": "Come raggiungerci?",
  "maps.get_directions": "Ottieni indicazioni",

  "room-categories.air-conditioning": "Aria condizionata",
  "room-categories.complimentary-dressing": "Vestiario omaggio",
  "room-categories.work-area": "Area lavoro",
  "room-categories.private-balcony": "Balcone privato",
  "room-categories.cable": "Cavo",
  "room-categories.safe-box": "Cassaforte",
  "room-categories.sommier-beds": "Letti sommier",
  "room-categories.room": "Camera",
  "room-categories.hydromassage": "Idromassaggio",
  "room-categories.coffee-machine": "Macchina da caffè",
  "room-categories.minibar": "Minibar",
  "room-categories.hairdryer": "Asciugacapelli",
  "room-categories.selection-of-pillows": "Selezione di cuscini",
  "room-categories.ironing-service": "Servizio stireria",
  "room-categories.smart-tv": "Smart TV",
  "room-categories.king-size-bed": "Letto king size",
  "room-categories.phone": "Telefono",
  "room-categories.tv-lcd": "TV LCD",
  "room-categories.satellite-tv": "TV satellitare",
  "room-categories.street-view": "Vista strada",
  "room-categories.garden-view": "Vista giardino",
  "room-categories.sea-view": "Vista mare",
  "room-categories.wifi": "Wifi",
  "room-categories.ketle": "Bollitore elettrico",
  "room-categories.fridge": "Frigorifero",
  "room-categories.dishwasher": "Lavastoviglie",
  "room-categories.oven": "Forno",
  "room-categories.freezer": "Congelatore",
  "room-categories.water-heater": "Scaldabagno",
  "room-categories.plates-glasses": "Piatti e bicchieri",
  "room-categories.cutlery-dishes": "Posate e stoviglie",
  "room-categories.microwave": "Microonde",
  "room-categories.kettle": "Bollitore elettrico",
  "room-categories.nespresso-machine": "Macchina Nespresso",

  "room-categories.toilette-with-shower-box": "Bagno con box doccia",
  "room-categories.sofa-bed": "Divano letto",
  "room-categories.partial-sea-view": "Vista mare parziale",
  "room-categories.welcome-amenities": "Servizi di benvenuto",
  "room-categories.shower": "Doccia",
  "room-categories.bathtub": "Vasca da bagno",
  "room-categories.double-sink": "Doppio lavabo",
  "room-categories.connected-rooms": "Camere comunicanti",
  "room-categories.king-or-twin-beds": "Letto king size o letti singoli",
  "room-categories.los-troncos-view": "Vista del quartiere Los Troncos",
  "room-categories.daily-courtesy-water": "Acqua di cortesia giornaliera",
  "room-categories.daily-courtesy-capsule-dilmah": "Capsula o infuso Dilmah di cortesia giornaliera",
  "room-categories.stay-courtesy-capsule-dilmah": "Capsula o infuso Dilmah di cortesia per il soggiorno",


  "meeting_rooms.dvd-player": "Lettore DVD",
  "meeting_rooms.high-speed-wi-fi": "Wi-Fi ad alta velocità",
  "meeting_rooms.independent-access": "Accesso indipendente",
  "meeting_rooms.lunch-service": "Servizio pranzo",
  "meeting_rooms.meeting-room": "Sala riunioni",
  "meeting_rooms.megaphone": "Megafono",
  "meeting_rooms.microphone": "Microfono",
  "meeting_rooms.smart-tv": "Smart TV",

  "meeting_rooms.video-projection": "Proiezione video",
  "meeting_rooms.capacity": "Capacità:",
  "meeting_rooms.people": "persone.",
  "welcome.title": "Benvenuto nel nostro Hotel!",
  "welcome.subtitle": "Vi auguriamo un piacevole soggiorno!",
  "welcome.text":
    "<b>Mi chiamo ViCo e sarò il tuo concierge virtuale!</b> Sono disponibile 24 ore su 24 e puoi chiedermi qualsiasi cosa! Per farlo, accedi alla sezione 'Richiesta' da cui puoi ordinare il servizio in camera, la pulizia, le forniture per la stanza, ecc.",
  "welcome.text-costa-galana":
    "<b>Con il nostro servizio di Concierge Mobile</b>, puoi ricevere attenzione personalizzata 24 ore su 24 per soddisfare le tue preferenze, richieste e raccomandazioni... <br /><br />Dal comfort del tuo dispositivo, puoi richiedere la pulizia della stanza, il servizio in camera, prenotazioni al ristorante e alla spa, tra le altre cose. <br /><br />Clicca su 'Inizia' ed entra nella sezione Richiesta.<br /><br />Se lo desideri, puoi chiamare l'interno 99 dalla tua stanza.",
  "welcome.text-hostz-becozy": "Benvenuti al nostro Becozy Basel, troverete tutto ciò di cui avete bisogno per sfruttare al massimo il vostro soggiorno.<br><br>Attraverso questo portale, potete migliorare la vostra esperienza con i nostri servizi disponibili, esplorare la nostra proprietà, scoprire cosa fare nella zona e molto altro.",
  "welcome.text-hostz-san-carlo": "Benvenuti al nostro Hotel San Carlo a Lugano, troverete tutto ciò di cui avete bisogno per sfruttare al massimo il vostro soggiorno.<br><br>Attraverso questo portale, potete migliorare la vostra esperienza con i nostri servizi disponibili, esplorare la nostra proprietà, scoprire cosa fare nella zona e molto altro.",
  "welcome.text-hostz-blacksummit": "Benvenuti al Black Summit Resort a Laax! In questo portale troverete tutto ciò di cui avete bisogno per sfruttare al massimo il vostro soggiorno.<br><br>Attraverso questo portale, potete migliorare la vostra esperienza con i nostri servizi disponibili, esplorare la nostra proprietà, scoprire cosa fare nella zona e molto altro.",
  "welcome.text-hostz-betahouse": "Benvenuti! Il check-in è stato effettuato.",
  "welcome.text-hostz-themyde": "<br/><br/><b>Benvenuto! Ora sei registrato. </b>Trova tutti i tuoi dettagli di accesso nella sezione Informazioni di accesso del tuo Dashboard.<br/><br/></br/>",
  "welcome.text-hostz-arosa": "<br/><br/><b>Benvenuto! Ora sei registrato. </b>Trova tutti i tuoi dettagli di accesso nella sezione Informazioni di accesso del tuo Dashboard.<br/><br/></br/>",
  "welcome.text-hostz-swissstay": "Benvenuti! Il check-in è stato effettuato. Ora potete trovare tutte le istruzioni per l'accesso nella sezione Informazioni di Accesso della vostra dashboard.",
  "welcome.text-hostz-steiners": "Benvenuti! Il check-in è stato effettuato. Ora potete trovare tutte le istruzioni per l'accesso nella sezione Informazioni di Accesso della vostra dashboard.",

  "welcome.subtitle-offgrid": "Benvenuto alla tua Guida per la Baita :)",
  "welcome.text-offgrid": "Qui troverai tutto ciò di cui hai bisogno per il tuo soggiorno – dal tuo <b>check-in online</b> e <b>informazioni sull'arrivo</b> a utili consigli per il tuo tempo nella baita.<br><br>Se hai qualsiasi domanda, sentiti libero di contattarci in qualsiasi momento – siamo felici di aiutarti!<br>Per questioni urgenti, inviaci semplicemente un messaggio su <b>WhatsApp al +49 30 54806375</b>.",
  "welcome.footer-offgrid": "👉 <b>Per un facile accesso</b>, puoi salvare la Guida per la Baita nella tua schermata iniziale. Basta toccare <b>\"accetta\"</b> e trascinare l'icona dove vuoi. Non occupa spazio e puoi rimuoverla in qualsiasi momento dopo il tuo soggiorno.<br><br><b>Ti auguriamo un meraviglioso soggiorno!</b> 🌿",
  "welcome.room-offgrid": "Baita",

  "welcome.footer-hostz": "Per facilitare l'accesso, vi consigliamo di attivare le notifiche e di creare un collegamento sulla schermata iniziale. Questo vi aiuterà a rimanere aggiornati sulle informazioni importanti relative al vostro soggiorno e vi permetterà di fare facilmente richieste per rendere il vostro soggiorno ancora più confortevole.",
  "welcome.footer-hostz-betahouse": "Ora potete trovare tutte le istruzioni per l'accesso nella sezione Informazioni di Accesso della vostra dashboard.",

  "welcome.room": "Il numero della tua stanza è:",
  "welcome.room_bs": "Il tuo appartamento è:",
  "welcome.footer":
    "Per un accesso facile, permettimi di creare un collegamento sulla schermata principale. Devi solo cliccare su accetta e trascinarlo dove desideri posizionarlo. Non occupa spazio e puoi rimuoverlo quando lasci l'hotel.<br /><br /><b>Sarà un piacere assisterti!</b>",
  "welcome.start": "Inizia",
  "services.type.general": "Richieste",
  "services.type.room_service": "Servizio in Camera",
  "services.type.pool_service": "Servizio in Piscina",
  "services.type.room_supplies": "Forniture per la Stanza",
  "services.type.laundry": "Lavanderia",
  "services.type.porter": "Portiere",
  "services.type.tray_collection": "Raccolta Vassoi",
  "services.type.pressing": "Stireria",
  "services.type.housekeeping": "Pulizie",
  "services.type.wakeup_call": "Sveglia Telefonica",
  "services.type.car_valet": "Parcheggiatore",
  "services.type.concierge": "Concierge",
  "services.type.lost_objects": "Oggetti Smarriti",
  "services.type.breakage_report": "Segnalazione Guasti",
  "services.type.services_booking": "Prenotazione Servizi",
  "services.type.review_tracking": "Ticket di Risoluzione per il Tuo Feedback",
  "services.type.up_selling": "Extra",
  "services.type.items_sales": "Prodotti",
  "services.housekeeping.do-not-clean-today": "Non pulire la mia stanza oggi",
  "services.type.gift_store": "Negozio di Regali",
  "services.housekeeping.horary":
    "Ricorda che l'orario per richiedere la pulizia della stanza è dalle 10:00 alle 15:00. Altrimenti la stanza non sarà pulita.",
  "services.housekeeping.horary-costa-galana":
    "Ricorda che l'orario per richiedere la pulizia della stanza è dalle 7:00 alle 17:00.",
  "services.housekeeping.do-not-change-towels": "Non cambiare gli asciugamani oggi",
  "services.housekeeping.button-title": "Invia richiesta",
  "services.donotdisturb.button-title-activate":
    "Attiva la modalità <b>NON DISTURBARE</b>",
  "services.donotdisturb.button-title-disable":
    "Disattiva la modalità <b>NON DISTURBARE</b>",
  "services.donotdisturb.extra-info": "Finché la modalità <b>NON DISTURBARE</b> è attiva, non sarà possibile effettuare pulizie o rispondere alle tue richieste.",
  "services.do-not-change-towels": "Non cambiare gli asciugamani",
  "services.sent-text":
    "<b>Richiesta Inviata!</b> Non appena sarà processata sarai notificato. Puoi anche seguirne l'andamento dalla schermata <b>Dashboard</b>.",
  "services.go-to-requests": "Vai alla Dashboard",
  "services.go-to-home": "Vai alla Home",
  "services.status.pending": "In attesa",
  "services.status.observed": "In revisione",
  "services.status.in_progress": "In corso",
  "services.status.in_transit": "Sulla strada",
  "services.status.accepted": "Accettata",
  "services.status.done": "Consegnata",
  "services.status.canceled": "Cancellata",
  "services.status.reviewed": "Recensita",
  "services.status.on_hold": "In attesa",
  "services.status.seated": "Accomodato",
  "services.status.confirmed": "Confermato",
  "services.active-request": "{0} richiesta attiva!",
  "services.active-requests": "{0} richieste attive!",
  "select...": "Seleziona...",
  "services.confirm-request": "La tua richiesta è completa?",

  "smartlocks.swipe-to-open": "SCORRI PER APRIRE",
  "smartlocks.pin-code-arosa-explanation": "Dopo aver inserito il PIN CODE, devi premere i pulsanti # o ↵ (enter) per confermare.",

  "status.messages": "Nuovi messaggi!",
  "status.no_messages": "Non abbiamo ancora risposto alla tua richiesta su questo argomento. Ti risponderemo a breve.",
  "status.more": "Altro sul tuo soggiorno",
  "status.faqs": "Domande Frequenti",
  "status.faqs_description": "Tutte le informazioni in un unico posto",
  "status.contact": "Contattaci",
  "status.contact_whatsapp": "Scrivici un messaggio WhatsApp",
  "status.contact_description": "Siamo qui per aiutarti!",
  "status.settings.btnDescription_facilities_arosa":"Grandi offerte dai nostri partner",
  "status.checkin_alert": "Aggiornamenti sul tuo Check-In",
  "status.checkin_alert_offgrid": "Neuigkeiten zu deinem Check-in",
  "status.checkin_edit": "Aggiorna le informazioni del check-in",
  "status.checkout_description": "Registra il tuo check-out",
  "status.checkin.chat": "Messaggi di Check-in",
  "status.stay.info": "Informazioni sul soggiorno",
  "status.stay_description": "Informazioni sul tuo soggiorno",
  "status.checkin.chat-desc": "Messaggi durante il tuo processo di check-in",
  "status.settings": "Notifiche",
  "status.settings_description": "Gestisci le tue impostazioni",
  "status.wifi": "WiFi",
  "status.wifi_description": "Accesso WiFi",
  "status.wifi_name": "Nome della rete",
  "status.wifi_password": "Password",
  "status.wifi_no_password": "Nessuna (rete aperta)",
  "status.garbage": "Istruzioni per lo smaltimento dei rifiuti",
  "status.parking_info": "Istruzioni per il parcheggio",
  "status.garbage_description": "Tutto quello che devi sapere",
  "status.extra-bed": "Istruzioni letto aggiuntivo",
  "status.extra-bed_description": "Scopri come preparare il tuo letto aggiuntivo.",
  "status.parking_info_description": "Tutto quello che devi sapere",
  "status.access_code": "Codici di accesso",
  "status.room_access_code": "Codici di accesso alla stanza",
  "status.room_keys": "Chiavi della camera",
  "status.room_keys_description": "Puoi ritirarle nelle cassette delle chiavi all'ingresso",
  "status.room_keys_description_becozy": "Ritirale nella cassetta portachiavi sulla porta della tua camera",
  "status.room_keycard": "Chiave elettronica della camera",
  "status.room_keycard_description": "Basta ritirarla alla reception",
  "status.apartment_keys": "Chiavi dell'appartamento",
  "status.apartment_keys_description": "Ritira semplicemente le chiavi dalla cassetta portachiavi all'ingresso principale",
  "status.access_code_one": "Codice di accesso",
  "status.access_code.pin_code": "Codice PIN",
  "status.access_code_hostz": "Codici di accesso all'appartamento",
  "status.access_information": "Informazioni di accesso",
  "status.access_information_extramsg_steiners": "La reception è aperta tutti i giorni dalle {0} alle {1} e si trova dopo la porta d’ingresso principale, sulla sinistra",
  "status.access_information_description": "Tutto ciò di cui hai bisogno per accedere alla proprietà",
  "status.access_code_description": "Informazioni di accesso",
  "status.access_code.main_entrance": "Porta d'ingresso",
  "status.access_code.main_door": "Codice di accesso all'ingresso principale",
  "status.access_code.room_door": "Codice della cassetta di sicurezza della stanza",
  "status.access_code.ladder": "Codice della scala",

  "status.access_information.access_to_room_themyde": "Accesso al tuo appartamento",
  "status.access_code.ladder_themyde": "Porta d’ingresso principale / Codice della scala",

  "status.access_code.hostz-becozy": "All’ingresso principale dell’hotel troverete un tastierino sul lato sinistro. Inserite il codice di accesso dell’hotel per entrare.<br /><br />Una volta all’interno, la chiave della vostra camera sarà in una cassetta portachiavi fissata direttamente alla porta della vostra camera.Per aprire la cassetta, inserite il codice e tirate la piccola leva sulla sinistra per aprire la cassetta e prendere la chiave della vostra camera.",

  "status.access_information.access_to_hotel": "Accesso all’hotel",
  "status.access_information.accesses_swissstay": "Accessi",
  "status.access_information.access_to_room": "Accesso alla tua camera",

  "status.access_code.main_entrance_themyde": "DOORS & ENTRYWAYS",
  "status.access_information.access_to_room_cover": "Durante il soggiorno troverai qui le istruzioni per ottenere le chiavi di accesso",
  "status.access_information.access_to_room_cover_arosa": "Disponibile alle 16:00",

  "status.access_information.access_to_room_description_cozy": "Ritira la tua chiave magnetica dalle cassette verdi (Keynest) nella hall.",
  "status.access_information.main_entrance_description_steiners": "La porta è aperta durante il giorno. <br>Se è chiusa, si prega di utilizzare il codice qui sotto per aprire la KEYBOX N.1 e usare la tessera digitale all'interno per aprire la porta principale.",
  "status.access_information.access_to_room_description_steiners": "Prendi la tua key card dalle cassette delle chiavi verdi situate al 2° piano.",

  "status.access_instructions": "Istruzioni di accesso",
  "status.access_instructions_description": "La tua procedura di accesso",
  "status.access_code.key_collection_code": "Codice di ritiro chiavi",
  "status.access_code.key_dropoff_code": "Codice di consegna chiavi",
  "status.access_code.key_dropoff": "Consegna delle chiavi",
  "status.access_code.key_dropoff_instructions": "Lascia la chiave nella scatola nera accanto alla scatola verde dove hai ritirato le chiavi.",
  "status.access_code.key_card_collection_code": "Codice di ritiro della carta",
  "status.access_code.key_card_dropoff_code": "Codice di consegna della carta",

  "status.access_information.before_checkin": "I dettagli di accesso saranno disponibili il giorno del check-in.",
  "status.access_information.before_checkin_with_hours": "Il codice della porta principale dell'hotel sarà visibile dalle {0} il giorno del check-in. I dettagli della tua camera (numero e codice della cassetta delle chiavi) saranno visibili dalle {1} lo stesso giorno.",
  "status.access_information.before_checkin_with_hours_themyde": "Potrai vedere le tue informazioni di accesso alle {0} (orario del check-in)",
  "status.access_information.before_checkin_with_hours_cozy": "Le informazioni di accesso saranno visibili il giorno del check-in alle {0}, solo se il modulo di check-in è stato completato e il pagamento effettuato (incluso il deposito cauzionale di {1}).",
  "status.access_information.before_checkin_with_hours_steiners": "Le informazioni di accesso saranno visibili il giorno del check-in a partire dalle {0}, solo se il modulo di check-in è stato compilato. Se avete appena effettuato il pagamento e l’orario di check-in è già passato, vi preghiamo di attendere 3–5 minuti affinché la transazione venga elaborata. Una volta approvata, le informazioni saranno visibili automaticamente.",
  "status.access_information.before_checkin_with_hours_no_sd": "Le informazioni di accesso saranno visibili il giorno del check-in alle {0}, solo se il modulo di check-in è stato completato e il pagamento effettuato.",
  "status.access_information.before_checkin_main": "Sei il benvenuto a entrare in hotel e goderti i suoi servizi a partire dalle {0} del mattino. Puoi anche lasciare i tuoi bagagli nel deposito mentre aspetti che la tua camera sia pronta per il check-in alle {1}. I dettagli della camera verranno condivisi alle {1}.",
  "status.access_information.before_checkin_room": "Il codice della porta principale dell'hotel sarà visibile dalle {0} il giorno del check-in. I dettagli della tua camera (numero e codice della cassetta delle chiavi) saranno visibili dalle {1} lo stesso giorno.",
  "status.access_information.after_checkin": "Il tuo soggiorno è terminato e i dettagli di accesso non sono più disponibili. Grazie per aver soggiornato nel nostro hotel — speriamo di poterti accogliere di nuovo molto presto!",
  "status.access_information.main_entrance": "Ingresso principale",
  "status.access_information.main_entrance_code": "Codice d'ingresso principale",
  "status.access_information.main_entrance_code_sigma": "Codice d'ingresso principale & Codice d'ingresso posteriore",
  "status.access_information.main_entrance_code_swissstay": "Accesso principale",
  "status.access_information.main_entrance_code_and_skiroom_code": "Codice d'ingresso principale & Codice della sala di ski",
  "status.access_information.room_keybox_code": "Codice della cassetta delle chiavi (situata accanto alla porta della tua camera)",
  "status.access_information.room_keybox_code_arosa": "Codice della cassetta delle chiavi (La cassetta si trova SULLA PORTA DELLA TUA CAMERA)",
  "status.access_information.please_use_main_key": "Si prega di usare la CHIAVE PRINCIPALE",
  "status.access_information.link_modal_video": "Guarda questo breve video per vedere come funziona il check-in",
  "status.access_information.link_modal_video_themyde": "Guarda questo breve video per vedere come funziona il check-in",
  "status.access_information.title_modal_video": "Come usare",
  "status.access_information.room_lock_box_code": "Codice della cassetta portachiavi",
  "status.access_information.room_lock_box_location": "Posizione della cassetta portachiavi",

  "status.location": "Posizione",
  "status.location_description": "Ottieni indicazioni stradali per raggiungere la proprietà.",
  "status.location_description_swissstay": "Ottieni indicazioni per l'appartamento qui.",
  "status.parking": "Parcheggio",
  "status.parking_description": "Accesso e Regole",

  "bookable.limit": "Prenota prima di",

  "account.add-device": "Aggiungi dispositivo",
  "account.stay": "Soggiorno",
  "account.room": "Camera",
  "account.more-info": "Ulteriori informazioni",
  "account.guest": "Ospite",
  "account.charges": "Addebiti",
  "account.payments": "Pagamenti",
  "account.accommodation": "Alloggio",
  "account.accommodation_description": "Pernottamento",
  "account.citytax": "Tassa di soggiorno",
  "account.foodandbeverages": "Cibo e bevande",
  "account.foodandbeverages_description": "Consumazioni al bar, ristorante, ecc.",
  "account.other": "Altri addebiti",
  "account.other_description": "Altri costi del soggiorno",
  "account.download": "Scarica",
  "account.invoices": "Fatture",
  "account.balance": "Saldo",
  "account.chat": "Se hai domande sulla fattura, non esitare a contattarci.",

  "review.rate": "Valutazione:",
  "review.rate_us": "Valutaci!",
  "review.thanks": "Grazie per averci valutato!",
  "review.extra_rate": "Feedback aggiuntivo",
  "review.extra_rate_text": "Queste valutazioni ci aiutano a migliorare il nostro servizio",
  "review.sending_response": "Invio della risposta…",
  "review.rate-placeholder": "Lascia il tuo feedback qui...",
  "review.already-rated": "Grazie per averci valutato, il tuo feedback è molto prezioso.",
  "review.already-rated-button": "Vorrei cambiare la mia valutazione.",
  "review.average": "Media",
  "review.general": "Generale",
  "review.contact": "Per favore, condividi i tuoi dettagli di contatto così possiamo seguirti nella tua recensione.",
  "review.screen_title": "Recensione",
  "review.flow_type_rating": "Valutazione",
  "review.flow_type_single_choice": "Scelta singola",
  "review.flow_type_opinion_scale": "Scala di opinione",
  "review.flow_type_ranking": "Classifica",
  "review.flow_type_landing": "Landing",

  "request.detail-title": "Dettaglio richiesta",
  "request.delivery-point": "Punto di consegna",
  "request.your-request": "La tua richiesta",
  "request.customize_next": "Personalizzala nella schermata successiva",
  "request.continue_customize": "Continua e personalizza",
  "request.products_not_available": "Prodotti non disponibili al momento",
  "request.product_not_available": "Prodotto non disponibile al momento",
  "request.available-time": "Prodotto disponibile nei seguenti orari",
  "request.item-out-of-hours": "Prodotto non disponibile in quest'ora",
  "request.available-time-from-to": "{0} a {1}hs",
  "request.product": "Prodotto",
  "request.products": "Prodotti",
  "request.creating-order": "Creazione ordine",
  "request.creating-order-title": "Stiamo creando il tuo ordine",
  "request.creating-order-description": "Stiamo inviando il tuo ordine all'hotel. Ci vogliono solo pochi secondi.",
  "request.order-created": "Ordine creato",
  "request.order-created-title": "Ordine creato con successo",
  "request.order-created-description": "Il tuo ordine e stato registrato. Tra un attimo ti porteremo al dettaglio per seguirlo.",
  "request.redirecting-to-order": "Reindirizzamento al dettaglio tra",
  "request.view-order-now": "Vedi ordine ora",
  "request.status-pending": "In sospeso",
  "request.confirm-cancel": "Questa azione cancellerà la tua richiesta. Vuoi procedere?",
  "request.only-one-for-type": "Puoi avere solo una richiesta aperta di questo tipo!",
  "request.lost_objects.observation": "Descrivi qui gli oggetti che hai perso in dettaglio e quando e dove potresti averli persi",
  "request.generic.observation": "Se desideri, lascia un commento qui.",
  "request.general.observation": "Per favore, dicci come possiamo aiutarti oggi!",
  "request.car_valet.observation": "Faccelo sapere se possiamo assisterti con il tuo veicolo...",
  "request.tray_collection.observation": "Hai istruzioni speciali per il tuo ritiro?",
  "request.breakage_report.observation": "Per favore, facci sapere cosa è rotto/non funziona",
  "request.housekeeping.observation": "Per favore, facci sapere se hai esigenze speciali qui",

  "request.option": "Opzione",
  "request.observations": "Commenti",
  "request.observations-placeholder": "Scrivi le tue osservazioni qui; faremo del nostro meglio per seguirle alla lettera.",
  "request.create.comment": "Lascia un commento sulla tua richiesta",
  "request.reserved-days": "Giorni Prenotati",

  "notifications.enable": "Abilita notifiche",
  "notifications.not_now": "Non ora",
  "notifications.accept": "<b>Importante:</b> Per favore abilita le notifiche per ricevere aggiornamenti in tempo reale sullo stato delle tue richieste!",
  "notifications.accepted": "<b class=\"text-success\">Notifiche abilitate!</b> Riceverai aggiornamenti in tempo reale sul processo di check-in e sulle tue richieste durante il soggiorno!",
  "notifications.blocked": "<b class=\"text-danger\">Notifiche bloccate!</b> Per favore, consenti le notifiche in modo da poter inviarti aggiornamenti importanti sullo stato delle tue richieste! Clicca sull'icona del lucchetto nella barra degli indirizzi del tuo browser. Clicca per attivare l'interruttore delle notifiche. Grazie!",
  "notifications.confirm-continue": "<b>Sei sicuro di voler continuare?</b> Le notifiche miglioreranno la tua esperienza complessiva durante il soggiorno!",
  "notifications.empty-title": "Non hai ancora notifiche!",
  "notifications.empty-text": "Quando ne riceverai una, verrà mostrata qui.",
  "notificacions.title": "Notifiche",
  "notifications.link.make-the-review": "Fai una recensione",

  "stay.add-device-use-qr": "Usa il QR da un altro dispositivo per aggiungerlo al soggiorno.",

  "yup.required": "Campo obbligatorio",
  "yup.only-letters": "Solo le lettere sono consentite",
  "yup.only-numbers": "Solo i numeri sono consentiti",
  "yup.only-numbers-and-letters": "Solo numeri e lettere",
  "yup.minimal-6-digits": "Deve contenere almeno 6 cifre",
  "yup.minimal-7-digits": "Deve contenere almeno 7 cifre",
  "yup.minimal-2-letters": "Deve contenere almeno 2 lettere",
  "yup.maximal-50-letters": "Non deve contenere più di 50 lettere",
  "yup.maximal-12-digits": "Non deve contenere più di 12 cifre",
  "yup.maximal-25-digits": "Non deve contenere più di 25 cifre",
  "yup.wrong-date": "Data errata",
  "yup.please-review": "Per favore, rivedi questo valore",
  "yup.email-invalid-format": "Formato email errato",

  "toast.do-not-disturb-mode-active-title": "Modalità 'Non disturbare' attiva",
  "toast.do-not-disturb-mode-active-text": "Per fare nuove richieste, devi prima disattivare la modalità 'Non disturbare'.",
  "toast.do-not-disturb-mode-active-link": "Disattiva",

  "payments.summary-of-charges": "Riepilogo delle spese",
  "payments.guarantee-deposit-paid": "La sua prenotazione ha già un deposito cauzionale attivo.",
  "payments.balance-paid": "La tua prenotazione non ha saldo pendente.",
  "payments.total-to-pay": "Totale da pagare",
  "payments.pay": "Vai al pagamento",
  "payments.retry-pay": "Riprova il pagamento",
  "payments.items-pay-with-deposit": "Le spese da pagare sono elencate di seguito:",
  "payments.guarantee-deposit": "Deposito cauzionale",
  "payments.guarantee-deposit-desc": "Questo importo verrà sospeso ma non verrà addebitato sulla tua carta di credito.",
  "payments.select-items-pay": "Selezionare gli articoli che si desidera pagare",
  "payments.payment-ok": "Il pagamento è stato effettuato con successo",
  "payments.payment-error": "Si è verificato un errore durante il tentativo di pagamento",
  "payments.payment-not-authorised": "Pagamento non autorizzato",
  "payments.pending-confirmation": "Stiamo confermando il pagamento con la banca. Non chiudere questa schermata.",
  "payments.pending-timeout": "La conferma del pagamento sta richiedendo più tempo del solito. Riprova o contatta la reception.",
  "payments.payment-unavailable-continue": "Pagamento non disponibile al momento, puoi continuare con il web check-in e pagare in seguito.",
  "payments.loading-component": "Caricamento del componente di pagamento in corso...",
  "payments.later": "Pagherò più tardi",
  "payments.confirm-pay-later": "Confermerai l'ordine e pagherai più tardi. Usa il pulsante Acquista qui sotto.",
  "payments.back-to-pay-later": "scegli di pagare più tardi",
  "payments.later-sancarlo": "Pagare in contanti alla reception. Si prega di notare che la nostra reception è aperta dalle 9:00 alle 18:00. Se il vostro arrivo è previsto dopo le 18:00, questa opzione non sarà disponibile.",
  "payments.msg_guarantee": "Al Black Summit Laax, richiediamo un deposito cauzionale per garantire un soggiorno sicuro e piacevole a tutti i nostri ospiti. Questo deposito funge da misura precauzionale per coprire eventuali danni potenziali alla proprietà, ai mobili o ai servizi, nonché spese accessorie come pulizie aggiuntive o check-out posticipati. Il deposito verrà rilasciato 7 giorni dopo il check-out, una volta che la proprietà sarà stata ispezionata e non saranno stati riscontrati problemi. Il rimborso verrà elaborato sul metodo di pagamento originale.",
  "payments.msg_guarantee_72hs": "Si prega di ricordare che un deposito di {0} CHF deve essere riscosso come misura obbligatoria 72 ore prima del vostro arrivo. Riceverete una notifica via e-mail come promemoria.",
  "payments.older": "Pagamento precedente",

  "facilities.Carta_Belleza": "Carta dei Trattamenti",
  "spa.Carta_Tratamientos": "Menu dei Massaggi",
  "facilities.Carta_SPA": "Menu",
  "home.chat-24-7": "Chat 24/7",
  "home.book-a-room": "Prenota una stanza",
  "home.book-an-apartment": "Prenota un appartamento",

  "door.main": "Principale",
  "door.back": "Posteriore",
  "room.address": "Indirizzo",
  "room.number": "Numero della camera",
  "room.floor": "Piano della camera",
  "apartment.address": "Indirizzo dell'appartamento",
  "apartment.number": "Appartamento",
  "apartment.floor": "Piano dell'appartamento",

  "public.bookable.init": "Seleziona il numero di persone e la data per verificare la disponibilità",
  "public.bookable.sent-text": "<b>Richiesta inviata!</b> <br/>Riceverai una notifica quando la prenotazione sarà elaborata.",
  "public.bookable.fill-data": "Per favore, inserisci le seguenti informazioni per completare la tua prenotazione per la giornata:",
  "public.edit-hour": "Modifica orario",
  "public.input.name-and-surname": "Nome e cognome",
  "public.input.phone": "Telefono",
  "public.input.email": "Email",
  "public.input.observations": "Osservazioni",
  "public.bookable.gala-experience": "Have you attended a Hotel Gala before?",
  "public.bookable.gala-experience.required": "Please select an option",
  "public.input.location": "Posizione",
  "public.input.location.arena": "Sombrilla arena",
  "public.input.location.piscina": "Sombrilla piscina",
  "public.input.location.carpa": "Carpa",
  "public.input.tent": "Numero di carpa",
  "public.bookable.list-empty": "Nessun servizio disponibile per la prenotazione.",
  "general.processing-request": "Elaborazione richiesta...",
  "public.dashboard.home": "Home",
  "public.dashboard.services": "Servizi",
  "public.dashboard.my-profile": "Il mio profilo",
  "complete-to-web-checkin": "Check-in online",
  "public.request.status.canceled-msg": "La richiesta è stata annullata.",
  "public.personal-information": "Informazioni personali",
  "public.input.number": "Numero",
  "services.type.beach_service": "Servizio di spiaggia",
  "services.make-your-reservation": "Fai la tua prenotazione",  
  "services.make-your-reservation-button": "Prenota i nostri servizi",  
  "service.type.request": "Richiesta",
  "public.request.payment-status.pay-again": "Riprova il pagamento",
  "public.request.payment-status.not-captured": "Il pagamento non può essere capturato. Per favore, riprova per poter finalizzare la tua richiesta.",
  "public.reservation.not-found": "Dettagli della prenotazione non trovati",
  "public.reservation.welcome": "Ciao {0}, ecco i dettagli della tua prenotazione:",
  "public.reservation.date-and-hour": "Data e ora",
  "public.reservation.people": "Persone",
  "public.reservation.adults": "Adulti",
  "public.reservation.adult": "Adulto",
  "public.reservation.children": "Bambini",
  "public.reservation.child": "Bambino",
  "public.reservation.state": "Stato",
  "public.reservation.observations": "Osservazioni",
  "public.request.cancel-assistance": "Annulla assistenza",
  "public.request.cancel-request": "Annulla", 
  "public.reservation.status.remember-status": "Accettato",
  "public.dashboard.logout": "Effettuare il logout",
  "public.dashboard.welcome": "Benvenuto, {0}!",
  "public.dashboard.no-reservations": "Non hai prenotazioni attive",
  "public.reservation.view-reservations": "Vedi tutte le mie prenotazioni",
  "public.reservation.confirm": "Conferma",
  "public.reservation.confirm_msg": "Puoi confermare la tua prenotazione fino a 72 ore prima dell'orario di inizio.",
  "public.reservation.status.validating": "Elaborazione richiesta",
  "public.reservation.confirmated-at": "Prenotazione confermata il",
  "public.request.forbidden.title": "Questa richiesta non può essere visualizzata",
  "public.request.status.validating-msg": "La tua richiesta è in fase di elaborazione, ti notificheremo quando sarà pronta.",
  "public.request.forbidden.desc": "Questa richiesta non corrisponde all'utente corrente.<br/>Per favore, assicurati di accedere con l'utente corretto.<br/>Se ritieni che si tratti di un errore, contatta il supporto.",
  "public.request.forbidden.button": "Vai al dashboard",
  "public.reservation.status.accepted": "Richiesta accettata",
  "public.reservation.status.canceled": "Annullato",
  "public.reservation.status.pending": "Richiede conferma",
  "public.reservation.status.confirmed": "Confermato",
  "public.request.confirmed": "Richiesta confermata il",
  "public.reservation.status.confirmed": "Confermato",
  "public.dashboard.requests": "Richieste",

  "public.dashboard.not-found": "Profilo utente non trovato",
  "public.dashboard.my-data": "I miei dati",
  "public.dashboard.name": "Nome completo",
  "public.dashboard.email": "Email",
  "public.dashboard.phone": "Telefono",
  "public.dashboard.my-reservations": "Le mie prenotazioni",
  "public.dashboard.my-requests": "Le mie richieste",
  "public.request.not-found": "Dettagli della richiesta non trovati",
  "public.request.welcome": "Ciao {0}, ecco i dettagli della tua richiesta:",
  "public.request.date-and-hour": "Data e ora",
  "public.request.people": "Persone",
  "public.request.passengers": "Passagieri",
  "public.request.title": "Dettaglio della richiesta",
  "public.request.state": "Stato",
  "public.request.observations": "Osservazioni",
  "public.request.additional-observations": "Osservazioni aggiuntive",
  "public.request.view-requests": "Visualizza tutte le mie richieste",
  "public.request.confirm-assistance": "Confermare assistenza",
  "public.dashboard.go-to-my-reservations": "Vai alle mie prenotazioni",
  "public.dashboard.cgbeach.public_cart": "Piazza ordine",
  "menu.all": "Tutti",
  "menu.search": "Cerca nel menu...",
  "menu.search_room_service": "Cerca prodotto...",
  "menu.search_restaurant": "Cerca nel Ristorante...",
  "menu.category": "Categoria {0}",
  "menu.vegetarian": "Vegetariano",
  "menu.gluten_free": "Senza Glutine",
  "menu.items_not_found": "Nessun articolo configurato per questo servizio. Si prega di consultare l'amministratore.",
  "menu.fail_laod_items": "Errore durante il caricamento degli articoli del servizio. Riprovare più tardi.",
  "menu.price_without_taxes": "Prezzo senza imposte nazionali:",
  "no-hours.disabled.day": "Questo servizio non sarà disponibile per tutta la giornata di oggi.",
  "no-hours.disabled.general": "Fuori dalle ore",
  "no-hours.disabled.slot": "Questo servizio non è disponibile al momento. La invitiamo a riprovare più tardi.",
  "general.invalid-dates": "Non sono disponibili tariffe per periodi superiori a {0} giorni.",  
  "general.selected-days": "Giorni selezionati",
  "general.selected-day": "Giorno selezionato",
  "general.day": "Giorno",
  "general.no-rates-available-for-selected-dates": "Non sono disponibili tariffe per i giorni selezionati.",
  "general.must-select-passengers": "Selezionare quantità e passeggeri in almeno una categoria di passeggeri.",
  "upselling.no-availability": "Al momento, questa opzione non è disponibile per il tuo soggiorno.",
  "general.payment-method": "Metodo di pagamento",
  "general.select-passengers": "Selezionare i passagieri",
  "general.select-passenger": "Selezionare il passaggio",

  "days.sunday": "Domenica",
  "days.monday": "Lunedì",
  "days.tuesday": "Martedì",
  "days.wednesday": "Mercoledì",
  "days.thursday": "Giovedì",
  "days.friday": "Venerdì",
  "days.saturday": "Sabato",

  "public_cart.hours-label": "Orario di apertura",
  "public_cart.no-available-hours": "Nessun orario disponibile",
  "CHECKINS_FOUND_NONE_VALID": "La prenotazione non è ancora disponibile per il check-in. Riprova alla data di arrivo",
  "CHECKINS_FOUND_MORE_THAN_ONE_VALID": "Si è verificato un problema nel trovare la prenotazione per camera. Prova con il codice di prenotazione",
  "CHECKINS_FOUND_NONE_LASTNAME_VALID": "Non siamo riusciti a trovare la prenotazione",
  "kiosk.welcome.subtitle": "Check-in completato con successo",
  "kiosk.room": "Camera",
  "kiosk.checkin": "Check-in",
  "kiosk.checkout": "Check-out",
  "kiosk.download_app": "Scansiona per accedere a servizi aggiuntivi",
  "kiosk.scan_qr": "Scansiona il codice QR per accedere a servizi aggiuntivi",
  "kiosk.generating_qr": "Generazione QR in corso...",
  "kiosk.redirect_warning": "Ti reindirizziamo in {seconds} secondi...",
  "kiosk.go_to_identify": "Finalizza",
  "kiosk.logout.title": "Esci dal modo Kiosk",
  "checkin.document-info": "Informazioni del Documento",
  "checkin.personal-info": "Informazioni Personali",
  "checkin.location": "Posizione",
  "kiosk.back": "Indietro",
  "kiosk.login.title": "Inserisci il tuo PIN",
  "kiosk.login.description": "Per favore, inserisci il codice di accesso per continuare",
  "kiosk.login.button_access": "Accedi",
  "kiosk.login.button_loading": "Caricamento...",
  "kiosk.login.error_empty": "Per favore inserisci il PIN",
  "kiosk.login.error_invalid": "PIN non valido. Riprova.",
  "kiosk.login.error_process": "Errore durante l'accesso. Riprova.",
  "kiosk.login.copyright": "© {year} {hotel}. Tutti i diritti riservati.",
  "kiosk.login.pin": "Inserisci il PIN",
  "kiosk.logout.confirm": "Inserisci il tuo PIN per disconnetterti dal modo Kiosk",
  "kiosk.receiving-info": "Ricezione informazioni...",
  "kiosk.inactivity-warning-title": "Sei ancora lì?",
  "kiosk.inactivity-warning-message": "Sei stato inattivo. Se non rispondi nei prossimi secondi, la tua sessione terminerà automaticamente.",
  "kiosk.inactivity-countdown": "La sessione si chiuderà tra",
  "kiosk.inactivity-stay": "Sì, continua",
  "kiosk.inactivity-logout": "No, disconnetti"
}